import React from 'react';
import { Route, Switch } from 'react-router';

import Dashboard from './Dashboard';
import BillingInfo from './BillingInfo';

const HiredNumber = ( { match } ) => (
  <Switch>
    <Route
      path={`${match.url}/billing`}
      render={( props ) => <BillingInfo {...props} parentPath={match.url} />}
    />
    <Route
      path={match.url}
      render={( props ) => <Dashboard {...props} parentPath={match.url} />}
    />
  </Switch>
);

export default HiredNumber;
